import { string, number, shape, bool } from 'prop-types';

export const customer = shape({ name: string, email: string });

export const giftCardItem = shape({
  buyer: customer,
  receiver: customer,
  message: string,
  isGiftCard: bool,
  price: number,
  extras: number,
  subtotal: number,
  discount: number,
  total: number
});
